var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{ref:"trendChart",attrs:{"autoresize":"","option":_vm.trendScatterOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }